module.exports = __webpack_public_path__ + "static/media/021.964a5af1.jpg";